import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import {
  TodoAddResponse,
  TodoListResponse,
  TodoUpdateRequest,
  TodoUpdateResponse,
} from "./Todo.constants";

export const useTodoAddMutation = (): UseMutationResult<
  TodoAddResponse,
  AxiosError,
  TodoUpdateRequest
> =>
  useMutation<TodoAddResponse, AxiosError, TodoUpdateRequest>(
    async (requestValues: TodoUpdateRequest) => {
      const { data, status } = await axiosInstance.post("todo/", requestValues);
      data.status = status;

      return data;
    }
  );

export const useTodoUpdateMutation = (): UseMutationResult<
  TodoUpdateResponse,
  AxiosError,
  TodoUpdateRequest
> =>
  useMutation<TodoUpdateResponse, AxiosError, TodoUpdateRequest>(
    async (requestValues: TodoUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "todo/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useTodoDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  string
> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete(
      "todo/" + requestValues + "/"
    );

    return status;
  });

export const useTodoListMutation = (): UseMutationResult<
  TodoListResponse,
  AxiosError,
  any
> =>
  useMutation<TodoListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("todo/");

    return data;
  });
